import React, { ReactNode } from 'react';
import { Stack } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing/types';
import { CurrencyInputField, InterestInputField, RadioGroupField } from 'components/form';
import { MARKUP_TYPE } from '@trnsact/business-criteria/dist/src/models/rule-event/aftermarket/markup-type';
import { ProductConfig } from '../../../../types';

interface Props {
  rowIndex: number;
}

export const MarkupCell = ({ rowIndex }: Props) => {
  const { control } = useFormContext<ListingForm<ProductConfig>>();
  const markupCellValue = useWatch({ control, name: `bodyFields.${rowIndex}.markup` });

  if (!markupCellValue?.type) return null;

  const fieldMapper: Record<MARKUP_TYPE, ReactNode> = {
    [MARKUP_TYPE.PERCENTAGE]: (
      <InterestInputField
        control={control}
        textFieldProps={{ variant: 'outlined' }}
        name={`bodyFields.${rowIndex}.markup.value`}
      />
    ),
    [MARKUP_TYPE.FIXED]: (
      <CurrencyInputField
        allowNegative
        control={control}
        textFieldProps={{ variant: 'outlined' }}
        name={`bodyFields.${rowIndex}.markup.value`}
      />
    ),
  };

  return (
    <Stack>
      {fieldMapper[markupCellValue.type]}

      <RadioGroupField
        row
        control={control}
        name={`bodyFields.${rowIndex}.markup.type`}
        options={[
          { value: MARKUP_TYPE.FIXED, label: '$' },
          { value: MARKUP_TYPE.PERCENTAGE, label: '%' },
        ]}
      />
    </Stack>
  );
};
